
import BaseCmsBlock from '../../node_modules/sitis-nuxt/lib/cms/CmsBlockMixin';

export default BaseCmsBlock.extend({
  name: 'OrderServiceBlock',

  computed: {
    vars: function () {
      return this.$store.state.appState?.vars;
    },

  },

  methods: {
    sendMessage: function () {
      const title = this.values?.title || 'Заказать услугу';
      const reachGoal = this.values?.yandex_reach_goal || 'заказать_услугу';
      const type = this.values?.form_type || 'Заказать услугу';

      this.$store.commit('pop-up-back-call/open', {
        type: type,
        title: title,
        reachGoal: reachGoal,
      });
    },
  },
});
